import * as React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface ConfirmActionModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  message: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
}

const styles = {
  header: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#111111',
    marginBottom: '16px',
    lineHeight: '24px',
  } as React.CSSProperties,
  warningIcon: {
    fontSize: '20px',
    color: '#faad14',
    marginTop: '2px',
    marginRight: '8px',
  } as React.CSSProperties,
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '32px',
    paddingLeft: '32px',
  } as React.CSSProperties,
  description: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 400,
    color: '#666666',
    lineHeight: '20px',
    flex: 1,
  } as React.CSSProperties,
  footer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
  } as React.CSSProperties,
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    padding: '10px 24px',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    backgroundColor: '#fff',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#595959',
    boxShadow: '0 2px 0 rgba(0, 0, 0, 0.016)',
  } as React.CSSProperties,
  confirmButton: {
    height: '40px',
    padding: '10px 24px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#1659cb',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    boxShadow: '0 2px 0 rgba(0, 0, 0, 0.043)',
  } as React.CSSProperties,
};

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  message: confirmMessage,
  description = 'Are you sure you want to continue?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  return (
    <Modal
      title={null}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={480}
      centered
      closable={false}
      bodyStyle={{ padding: '32px' }}
    >
      <div>
        <div style={styles.header}>
          <ExclamationCircleOutlined style={styles.warningIcon} />
          {confirmMessage}
        </div>
        <div style={styles.content}>
          <div style={styles.description}>
            {description}
          </div>
        </div>
        <div style={styles.footer}>
          <Button onClick={onCancel} style={styles.cancelButton}>
            {cancelText}
          </Button>
          <Button onClick={onConfirm} style={styles.confirmButton}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmActionModal;
